<template>
  <div class="zj-search-result-table">
    <div class="zj-dropdown-fields">
      <ComponentDropdown
        syscode="EmergencyService"
        ukey="emergency_team_good_accidents"
        placeholder="擅长事故类型"
        v-on:onSelectChange="onEmergencyTypeSelectChange"
      ></ComponentDropdown>
      <ComponentDropdown
        syscode="EmergencyService"
        ukey="emergency_team_type"
        placeholder="专业救援队伍"
        v-on:onSelectChange="onTeamTypeSelectChange"
      ></ComponentDropdown>
    </div>
    <el-table :data="tableData" @row-click="rowclick" :show-header="false">
      <el-table-column>
        <template slot-scope="scope">
          <ComponentInfoPanel type="RescueTeam" v-bind:info="convert(scope.$index,scope.row)"></ComponentInfoPanel>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import { list } from "@/api/src/emergency_resourcesTeam";
import ComponentDropdown from "./Component-Dropdown";
import ComponentInfoPanel from "./Component-InfoPanel";
import { Row } from 'element-ui';

export default {
  components: {
    ComponentDropdown: ComponentDropdown,
    ComponentInfoPanel: ComponentInfoPanel
  },
  props: {
    targetUri: Object,
    center: {
      type: Object,
      default: function() {
        return [0, 0];
      }
    },
    searchText: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      EmergencyType:null,
      teamType: null,
      selectData: null
    };
  },
  mounted: function() {
    this.search();
  },
  methods: {
    convert(index, row) {
      var result = {
        index:(this.pageSize *(this.currentPage - 1)) + index + 1,
        ...row
      };
      return result;
    },
    search() {
      let searchInfo = {
        teamName: this.searchText,
        longitude: this.center[0] || 0,
        latitude: this.center[1] || 0,
        size: this.pageSize,
        current: this.currentPage,
        goodAccidentsType: this.EmergencyType,
        teamType: this.teamType,
      };
        
      list(searchInfo)
        .then(r => {
          r = r.data;
          this.tableData = r.records;
          this.total = r.total;
        })
        .catch(e => {
          console.log(e);
        });
    },
    // eslint-disable-next-line no-unused-vars
    rowclick(row, column, e) {
      // 给分发事件
      this.dispatch("ZjEmergencyOneMap", "poiselected", row.id);
      this.dispatch("ZjEmergencyOperations", "poiselected", row.id);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    onEmergencyTypeSelectChange(val) {
      this.EmergencyType = val;
      this.search();
    },
    onTeamTypeSelectChange(val) {
      this.teamType = val;
      this.search();
    }
  },
  watch: {
    center: function() {
      this.search();
    },
    searchText: function() {
      this.search();
    }
  }
};
</script>